// start:ng42.barrel
export * from './hotel-address.component';
// end:ng42.barrel



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/hotel-address/index.ts